var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"side-buttons"},_vm._l((_vm.buttons),function(btn,i){return _c('v-btn',{key:i,attrs:{"color":"primary","to":btn.to},on:{"click":btn.click}},[_vm._v(" "+_vm._s(btn.text)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }